import { useFormikContext } from 'formik'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { Button } from '@ui/components/Button'

import { createFormField } from '@global/formField/FormField'
import { TransactionFormActionButtonTemplate } from '@global/templates/TransactionFormActionButtonTemplate'

import { FieldWrapper } from '@shared/components/FieldWrapper'

interface PaymentAgentTransferClientFormValues {
  clientWallet: {
    name: string
  }
}

interface PaymentAgentTransferClientFieldsProps {
  onSubmit(values: PaymentAgentTransferClientFormValues): void
  onCancel(): void
}

const FormField = createFormField<PaymentAgentTransferClientFormValues>()
export const PaymentAgentTransferClientFields: React.FC<PaymentAgentTransferClientFieldsProps> = (
  props
) => {
  const { onSubmit, onCancel } = props

  const { values, isValid } = useFormikContext<PaymentAgentTransferClientFormValues>()

  const handleSubmitForm = () => {
    onSubmit(values)
  }

  const { t } = useTranslation()

  return (
    <React.Fragment>
      <FieldWrapper>
        <FormField name='clientWallet.name' label={t('Wallet.Client Wallet Name')} required />

        <TransactionFormActionButtonTemplate>
          <Button.Secondary size='lg' onClick={onCancel}>
            {t('Cancel')}
          </Button.Secondary>
          <Button.Primary size='lg' disabled={!isValid} onClick={handleSubmitForm}>
            {t('Confirm')}
          </Button.Primary>
        </TransactionFormActionButtonTemplate>
      </FieldWrapper>
    </React.Fragment>
  )
}
